<script lang="ts">
  import { pwa } from '../pwa.svelte';
</script>

{#if pwa.needRefresh}
  <div class="toast" role="status">
    <span>A new version of Kip is ready.</span>
    <div class="row">
      <button class="reload" onclick={() => pwa.reload()}>Reload</button>
      <button class="later" onclick={() => pwa.dismiss()}>Later</button>
    </div>
  </div>
{:else if pwa.offlineReady}
  <div class="toast subtle" role="status">Ready to use offline.</div>
{/if}

<style>
  .toast {
    position: fixed;
    left: 50%;
    bottom: calc(var(--tabbar-h) + 16px + env(safe-area-inset-bottom));
    transform: translateX(-50%);
    z-index: 70;
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: min(92vw, 420px);
    background: var(--ink);
    color: var(--cream);
    padding: 12px 16px;
    border-radius: 14px;
    box-shadow: var(--shadow-lift);
    font-size: 13px;
  }
  .toast.subtle {
    background: var(--cream-2);
    color: var(--ink-soft);
    border: 1px solid var(--line);
  }
  .row {
    display: flex;
    gap: 8px;
    align-self: flex-end;
  }
  .reload,
  .later {
    font-family: var(--mono);
    font-size: 11px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    border-radius: 8px;
    padding: 5px 12px;
  }
  .reload {
    background: var(--rooster);
    color: var(--cream);
    font-weight: 700;
  }
  .later {
    color: var(--cream);
    opacity: 0.7;
  }
</style>
